import { Button, Box } from "@mui/material";
import React, { useRef } from "react";
import { useImportVariance } from "containers/PolicyHistory/usePoliciesReview";
function ImportVariance({ hpKey, refreshData }) {
  const [importVariance] = useImportVariance();
  const fileRef = useRef();
  const clearFile = () => {
    fileRef.current.value = null;
  };
  const onImportVariance = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      console.log("No FIle");
      return;
    }
    var formData = new FormData();
    formData.append("file", file);
    formData.append("healthPlanKey", hpKey);

    await importVariance(hpKey, formData, () => {
      console.log("File uploaded successfully, refreshing data...");
      clearFile();
      refreshData();
    });
  };
  return (
    <Box>
      <input
        ref={fileRef}
        type="file"
        onChange={onImportVariance}
        style={{ display: "none" }}
        id="importVarianceButton"
      />
      <label htmlFor="importVarianceButton">
        <Button component="span">Import Variance</Button>
      </label>
    </Box>
  );
}

export default ImportVariance;
